import { render, staticRenderFns } from "./scanandgo.vue?vue&type=template&id=460aea6a&scoped=true&"
import script from "./scanandgo.vue?vue&type=script&lang=js&"
export * from "./scanandgo.vue?vue&type=script&lang=js&"
import style0 from "./scanandgo.vue?vue&type=style&index=0&id=460aea6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460aea6a",
  null
  
)

export default component.exports